<div id="base-apps">
    <div class="avp-box">
        <div class="top">
            <div class="user">
                <div class="image">
                    <one-avatar [imageUrl]="userAvartarUrl" size="40"></one-avatar>
                </div>
                <div class="name"><b>{{userFullname}}</b> - {{userInfo.email}}</div>
                <div class="info">
                    <a target="_blank" href="">Tài khoản</a> ·
                    <a href="" target="_blank">Trang chủ</a> ·
                    <a href="#" (click)="logout()">Đăng xuất</a>
                </div>
            </div>
        </div>
        <div class="sb scrollable __set __apscrollbar_parent __autohide" data-autohide="1" data-autoscroll="1">
            <div class="scrollin absolute __apscrollbar_target __scrolled" style="inset: 0px -12px 0px 0px;">
                <div class="__apscrollbar_wrap __autohide" style="padding-right:0px">
                    <div class="inner clear-fix">
                        <div class="app-group">
                            <div class="g-body">
                                <a class="item" target="_blank" href="http://task.anvietphatgroup.com/avp">
                                    <span class="image">
                                        <img src="http://task.anvietphatgroup.com/assets/avp-icons/wework.png">
                                    </span>
                                    <span class="text ap-xdot">AVP Task
                                        <em class="ap-xdot">Quản lý công việc</em>
                                    </span>
                                </a>
                                <a class="item" target="_blank" href="http://account.anvietphatgroup.com">
                                    <span class="image">
                                        <img src="http://task.anvietphatgroup.com/assets/avp-icons/account.png">
                                    </span>
                                    <span class="text ap-xdot">AVP Account
                                        <em class="ap-xdot">Tài Khoản</em>
                                    </span>
                                </a>
                                <a class="item" target="_blank" href="http://message.anvietphatgroup.com">
                                    <span class="image">
                                        <img src="http://task.anvietphatgroup.com/assets/avp-icons/chat.png">
                                    </span>
                                    <span class="text ap-xdot">AVP Message
                                        <em class="ap-xdot">Quản lý tin nhắn</em>
                                    </span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
